/* Label & Leaf — v2-flow PDP interactions (vanilla, no deps).
   Works generically off real product options; diary demo cards (book type,
   upsell) are optional extras toggled by section settings. */
(function () {
  'use strict';

  var root = document.getElementById('llp-pdp');
  if (!root) return;

  var config = {
    variants: [],
    addonsUrl: '/cart',
    cartUrl: '/cart',
    soldOutLabel: 'Sold out',
    unavailableLabel: 'Unavailable',
    errorMessage: 'Sorry — we could not add that. Please try again.'
  };
  try {
    config = Object.assign(config, JSON.parse(root.querySelector('[data-llp-config]').textContent));
  } catch (e) { /* defaults are fine for the harness */ }

  var isShopify = typeof config.cartUrl === 'string' && config.cartUrl.indexOf('/cart') === 0;

  var cta = root.querySelector('[data-llp-cta]');
  /* The label Liquid rendered, captured before anything overwrites it. Every
     restore (sold out → in stock, failed add, bfcache) comes back to this
     rather than rebuilding region wording in JS. */
  var ctaDefaultLabel = cta
    ? displayCtaLabel(cta.getAttribute('data-llp-cta-label') || cta.textContent).trim()
    : '';

  /* ---------- option card open/close ---------- */
  root.querySelectorAll('[data-llp-opt-toggle]').forEach(function (head) {
    head.addEventListener('click', function () {
      var card = head.closest('[data-llp-opt]');
      var open = card.classList.toggle('is-open');
      head.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });

  function setCardValue(key, value) {
    var card = root.querySelector('[data-llp-opt="' + key + '"]');
    if (card) {
      var v = card.querySelector('[data-llp-opt-value]');
      if (v) v.textContent = value;
    }
  }

  /* ---------- generic option selection ---------- */
  var selections = {};
  root.querySelectorAll('[data-llp-option][aria-pressed="true"]').forEach(function (btn) {
    selections[btn.getAttribute('data-llp-option')] = btn.getAttribute('data-llp-value');
  });

  /* The variant matching every value in `choice`, or null when that
     combination does not exist. Never fall back to the first variant: doing so
     priced and added something the shopper had not chosen. */
  function variantFor(choice) {
    var wanted = Object.keys(choice).map(function (k) { return choice[k]; });
    var list = config.variants || [];
    if (!wanted.length) return list[0] || null;
    var match = null;
    list.some(function (candidate) {
      var opts = candidate.options || [candidate.option1, candidate.option2, candidate.option3].filter(Boolean);
      var ok = wanted.every(function (w) { return opts.indexOf(w) !== -1; });
      if (ok) match = candidate;
      return ok;
    });
    return match;
  }

  function currentVariant() {
    return variantFor(selections);
  }

  function selectedBindingKey() {
    var binding = '';
    Object.keys(selections).some(function (key) {
      if (key.toLowerCase() === 'binding') {
        binding = selections[key] || '';
        return true;
      }
      return false;
    });
    return /hard/i.test(binding) ? 'hardcover' : 'wiro';
  }

  /* compare filenames: the storefront proxies the CDN under a different
     path prefix, and each width is a different query on the same file */
  function imageFile(url) {
    return String(url || '').split('?')[0].split('/').pop();
  }

  function refreshBindingGallery() {
    var binding = selectedBindingKey();
    root.querySelectorAll('[data-llp-binding-image]').forEach(function (image) {
      var source = image.getAttribute('data-llp-' + binding + '-src');
      var alt = image.getAttribute('data-llp-' + binding + '-alt');
      /* only swap on a real change: the page renders the selected binding with
         a responsive srcset, and replacing it on load would download it again.
         On a swap, clear the srcset or the browser keeps its candidate */
      if (source && imageFile(image.currentSrc || image.src) !== imageFile(source)) {
        image.removeAttribute('srcset');
        image.src = source;
      }
      if (alt) image.alt = alt;
    });
  }

  /* ---------- stock ----------
     Every variant in config carries `available` straight from Liquid, which
     already applies the untracked-is-available rule. A variant with no flag at
     all is treated as sellable — never block a sale on absent data — but a
     combination with no variant at all is not sellable. */
  function variantAvailable(v) {
    if (!v) return false;
    return v.available === undefined || v.available === null ? true : !!v.available;
  }

  function displayCtaLabel(label) {
    /* The live availability section predates its merge to main and escaped
       the captured ampersand twice. Normalise that trusted label before it is
       assigned through textContent, which otherwise displays literal &AMP;. */
    return String(label || '').replace(/&amp;/gi, '&');
  }

  function refreshAvailability(v) {
    if (!cta) return;
    var missing = !v;
    var ok = variantAvailable(v);
    cta.disabled = !ok;
    if (ok) { cta.removeAttribute('aria-disabled'); } else { cta.setAttribute('aria-disabled', 'true'); }
    var label = ctaDefaultLabel;
    if (missing) label = config.unavailableLabel || 'Unavailable';
    else if (!ok) label = config.soldOutLabel || 'Sold out';
    label = displayCtaLabel(label);
    if (String(cta.textContent).trim() !== label) cta.textContent = label;
    var note = root.querySelector('[data-llp-soldout]');
    if (note) {
      note.hidden = ok;
      if (!ok) note.textContent = label;
    }
  }

  /* grey out the values that cannot be combined with the current selection.
     They stay clickable — the CTA then explains why nothing can be added. */
  function refreshOptionAvailability() {
    root.querySelectorAll('[data-llp-option]').forEach(function (btn) {
      var trial = Object.assign({}, selections);
      trial[btn.getAttribute('data-llp-option')] = btn.getAttribute('data-llp-value');
      var candidate = variantFor(trial);
      var exists = !!candidate;
      var optionPrice = btn.querySelector('[data-llp-option-price]');
      if (optionPrice) optionPrice.textContent = candidate ? candidate.formattedPrice || '' : config.unavailableLabel;
      btn.classList.toggle('is-unavailable', !exists);
      if (exists) { btn.removeAttribute('aria-disabled'); } else { btn.setAttribute('aria-disabled', 'true'); }
    });
  }

  function refresh() {
    var v = currentVariant();
    refreshOptionAvailability();
    refreshBindingGallery();
    refreshDesignGallery();
    refreshAvailability(v);
    /* no variant for this combination: leave the price, the image and the
       ?variant= parameter pointing at the last real one */
    if (!v) return;
    var priceEl = root.querySelector('[data-llp-price]');
    if (priceEl && v.formattedPrice) priceEl.textContent = v.formattedPrice;
    var compareWrap = root.querySelector('[data-llp-compare-wrap]');
    var comparePrice = root.querySelector('[data-llp-compare-price]');
    if (compareWrap && comparePrice) {
      compareWrap.hidden = !(v.compareAt > v.price && v.formattedCompareAt);
      comparePrice.textContent = v.formattedCompareAt || '';
    }
    var img = root.querySelector('[data-llp-main-image]');
    var vImage = v.featured_image && (v.featured_image.src || v.featured_image);
    /* never clobber the artframe stage's flat art with a variant image */
    if (img && !img.closest('[data-llp-artframe]') && typeof vImage === 'string' && vImage) {
      /* only swap on a real change: the initial paint is server-rendered with
         a responsive srcset for the selected variant — replacing it on load
         would discard that and re-download the image */
      if (imageFile(img.currentSrc || img.src) !== imageFile(vImage)) {
        img.removeAttribute('srcset');
        img.src = vImage + (vImage.indexOf('?') === -1 ? '?' : '&') + 'width=1600';
      }
      var productTitle = img.getAttribute('data-llp-product-title');
      if (productTitle) {
        img.alt = productTitle + ' — ' + (selectedBindingKey() === 'hardcover' ? 'Hardcover' : 'Wiro');
      }
    }
    syncNotebookViews();
    /* persist the selection so refresh/share/customise all keep the binding */
    if (v.id && window.history && history.replaceState) {
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        history.replaceState(null, '', url.pathname + url.search + url.hash);
      } catch (e) { /* non-blocking */ }
    }
  }

  root.querySelectorAll('[data-llp-option]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var optionName = btn.getAttribute('data-llp-option');
      root.querySelectorAll('[data-llp-option="' + optionName.replace(/"/g, '\\"') + '"]').forEach(function (b) {
        var selected = b === btn;
        b.setAttribute('aria-pressed', selected ? 'true' : 'false');
        b.classList.toggle('is-selected', selected);
      });
      selections[optionName] = btn.getAttribute('data-llp-value');
      setCardValue(optionName, btn.getAttribute('data-llp-display-value') || selections[optionName]);
      /* wall-art frame stage follows Frame/Size selections (ll-art-frame.css) */
      root.querySelectorAll('[data-llp-artframe]').forEach(function (artStage) {
        var handleized = selections[optionName].toLowerCase().trim()
          .replace(/['"‘’“”]/g, '')
          .replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
        if (/frame/i.test(optionName)) artStage.setAttribute('data-frame', handleized);
        if (/^size$/i.test(optionName)) artStage.setAttribute('data-size', handleized);
      });
      refresh();
      if (/frame/i.test(optionName) && media) {
        var hero = visibleGalleryFigures().find(function (figure) {
          return figure.querySelector('[data-llp-artframe]');
        });
        if (hero) {
          media.scrollTo({ left: 0, behavior: 'instant' });
          if (syncDots) syncDots();
          var header = document.querySelector('.section-llp-header');
          hero.style.scrollMarginTop = ((header ? header.getBoundingClientRect().height : 0) + 12) + 'px';
          hero.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior:
            window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        }
      }
    });
  });

  /* unknown colour names get a deterministic muted swatch */
  root.querySelectorAll('[data-llp-autocolour]').forEach(function (b) {
    var name = b.getAttribute('data-llp-autocolour');
    var hash = 0;
    for (var i = 0; i < name.length; i++) hash = (hash * 31 + name.charCodeAt(i)) % 360;
    b.style.background = 'hsl(' + hash + ', 32%, 58%)';
  });

  /* ---------- diary demo: book type card ---------- */
  root.querySelectorAll('[data-llp-booktype]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      root.querySelectorAll('[data-llp-booktype]').forEach(function (b) {
        b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
      });
      var value = btn.getAttribute('data-llp-booktype');
      setCardValue('booktype', value);
      var subtitle = root.querySelector('.llp-pdp__subtitle');
      if (subtitle) {
        var binding = selections.Binding || 'Spiral bound';
        var bindingLabel = binding === 'Hardback' ? 'Hardcover' : 'Softcover Spiral';
        subtitle.textContent = 'B5 ' + bindingLabel + ' ' + value;
      }
    });
  });

  /* ---------- mobile media dots ---------- */
  var media = root.querySelector('[data-llp-media]');
  var dots = root.querySelector('[data-llp-dots]');
  var solarGallery = media && media.hasAttribute('data-llp-solar-gallery');
  var galleryDesign = null;
  function visibleGalleryFigures() {
    return Array.from(media.querySelectorAll('figure')).filter(function (figure) { return !figure.hidden; });
  }
  /* Dots are real controls: each one is a 44px button that scrolls the
     carousel to its slide and reports itself to assistive tech. */
  function buildDots(count) {
    if (!dots) return;
    dots.replaceChildren();
    var format = dots.getAttribute('data-format') || 'Show image [current] of [total]';
    for (var index = 0; index < count; index += 1) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'llp-pdp__dot' + (index === 0 ? ' is-active' : '');
      dot.setAttribute('aria-pressed', index === 0 ? 'true' : 'false');
      dot.setAttribute('aria-label', format.replace('[current]', String(index + 1)).replace('[total]', String(count)));
      dot.addEventListener('click', (function (slide) {
        return function () {
          var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          media.scrollTo({ left: slide * media.clientWidth, behavior: reduce ? 'auto' : 'smooth' });
        };
      })(index));
      dots.appendChild(dot);
    }
    dots.hidden = count < 2;
  }
  function refreshDesignGallery() {
    if (!solarGallery) return;
    var design = selections.Design;
    if (!design || design === galleryDesign) return;
    var figures = Array.from(media.querySelectorAll('[data-llp-design]'));
    if (!figures.some(function (figure) { return figure.getAttribute('data-llp-design') === design; })) return;
    galleryDesign = design;
    figures.forEach(function (figure) {
      var group = figure.getAttribute('data-llp-design');
      figure.hidden = !!group && group !== design;
    });
    media.scrollTo({ left: 0, behavior: 'instant' });
    buildDots(visibleGalleryFigures().length);
  }
  if (media && dots) {
    buildDots(media.querySelectorAll('figure').length);
    var syncDots = function () {
      var i = Math.round(media.scrollLeft / media.clientWidth);
      dots.querySelectorAll('.llp-pdp__dot').forEach(function (d, di) {
        d.classList.toggle('is-active', di === i);
        d.setAttribute('aria-pressed', di === i ? 'true' : 'false');
      });
    };
    media.addEventListener('scroll', function () { requestAnimationFrame(syncDots); }, { passive: true });
  }

  /* ---------- visible product video playback ---------- */
  if (media && typeof IntersectionObserver === 'function') {
    media.querySelectorAll('.llp-pdp__video video').forEach(function (video) {
      var visible = false;
      video.muted = true;
      video.playsInline = true;
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var nextVisible = entry.isIntersecting && entry.intersectionRatio >= 0.5;
          if (nextVisible === visible) return;
          visible = nextVisible;
          if (!visible) {
            video.pause();
            return;
          }
          if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
          var playback = video.play();
          if (playback && typeof playback.catch === 'function') playback.catch(function () {});
        });
      }, { threshold: [0, 0.5] });
      observer.observe(video);
    });
  }

  /* ---------- image zoom / look inside pills ---------- */
  var zoomDialog = root.querySelector('[data-llp-image-zoom]');
  var zoomImage = root.querySelector('[data-llp-image-zoom-image]');
  var zoomCaption = root.querySelector('[data-llp-image-zoom-caption]');
  var zoomClose = root.querySelector('[data-llp-image-zoom-close]');
  var zoomScrim = root.querySelector('[data-llp-image-zoom-scrim]');
  var lastZoomTrigger = null;

  function closeImageZoom() {
    if (!zoomDialog || !zoomDialog.hasAttribute('open')) return;
    if (typeof zoomDialog.close === 'function') zoomDialog.close();
    else zoomDialog.removeAttribute('open');
  }

  function openImageZoom(image, trigger) {
    if (!zoomDialog || !zoomImage || !image) return;
    lastZoomTrigger = trigger || null;
    var zoomSrc = image.getAttribute('data-llp-zoom-src') || image.currentSrc || image.src;
    /* the dialog shows the image far larger than the gallery tile: ask the
       CDN for the top rendition (capped at the source size server-side) */
    if (!image.getAttribute('data-llp-zoom-src') && /[?&]width=\d+/.test(zoomSrc)) {
      zoomSrc = zoomSrc.replace(/([?&]width=)\d+/, '$12048');
    }
    zoomImage.src = zoomSrc;
    zoomImage.alt = image.alt || '';
    var zoomRender = root.querySelector('[data-llp-image-zoom-render]');
    var frame = image.closest('[data-llp-artframe]');
    if (zoomRender) {
      zoomRender.replaceChildren();
      zoomRender.hidden = !frame;
      zoomImage.hidden = !!frame;
      if (frame) {
        var framed = frame.cloneNode(true);
        framed.removeAttribute('data-llp-artframe');
        var framedImage = framed.querySelector('img');
        /* the copy shows the enlarged URL; a srcset carried over from the
           gallery would win over it and keep the small candidate */
        framedImage.removeAttribute('srcset');
        framedImage.removeAttribute('sizes');
        framedImage.src = zoomSrc;
        framedImage.loading = 'eager';
        zoomRender.appendChild(framed);
      }
    }
    var figure = image.closest('figure');
    var caption = figure && figure.querySelector('figcaption');
    if (zoomCaption) zoomCaption.textContent = caption ? caption.textContent : 'Product image';
    document.body.classList.add('llp-image-zoom-open');
    if (typeof zoomDialog.showModal === 'function') zoomDialog.showModal();
    else zoomDialog.setAttribute('open', '');
    if (zoomClose) zoomClose.focus();
  }

  root.querySelectorAll('[data-llp-zoom-trigger]').forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      openImageZoom(trigger.querySelector('img'), trigger);
    });
  });

  root.querySelectorAll('[data-llp-zoom-trigger][role="button"]').forEach(function (trigger) {
    trigger.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); trigger.click(); }
    });
  });
  if (zoomClose) zoomClose.addEventListener('click', closeImageZoom);
  if (zoomScrim) zoomScrim.addEventListener('click', closeImageZoom);
  if (zoomDialog) {
    zoomDialog.addEventListener('click', function (event) {
      if (event.target === zoomDialog) closeImageZoom();
    });
    zoomDialog.addEventListener('close', function () {
      document.body.classList.remove('llp-image-zoom-open');
      if (lastZoomTrigger) lastZoomTrigger.focus({ preventScroll: true });
    });
    zoomDialog.addEventListener('cancel', function () {
      document.body.classList.remove('llp-image-zoom-open');
    });
  }

  /* Pinch, drag and double-tap inside the enlarged image. The dialog fills
     the screen, so the figure itself is scaled and panned with a transform
     and kept within the viewport. */
  function initPinchZoom(dialog) {
    var figure = dialog && dialog.querySelector('.llp-image-zoom__figure');
    if (!figure || !window.PointerEvent) return;
    var scale = 1, tx = 0, ty = 0;
    var pointers = new Map();
    var pinch = null, moved = false, lastTap = 0, lastTouch = 0;
    function clampPan() {
      var rect = figure.getBoundingClientRect();
      var baseW = rect.width / scale, baseH = rect.height / scale;
      var maxX = Math.max(0, (baseW * scale - Math.min(baseW, window.innerWidth)) / 2);
      var maxY = Math.max(0, (baseH * scale - Math.min(baseH * scale, window.innerHeight)) / 2 + Math.max(0, (baseH - window.innerHeight) / 2));
      tx = Math.max(-maxX, Math.min(maxX, tx));
      ty = Math.max(-maxY, Math.min(maxY, ty));
    }
    function apply() {
      clampPan();
      figure.style.transform = scale === 1 ? '' : 'translate(' + tx + 'px, ' + ty + 'px) scale(' + scale + ')';
      figure.classList.toggle('is-zoomed', scale > 1);
    }
    function setScale(next, cx, cy) {
      var previous = scale;
      scale = Math.max(1, Math.min(4, next));
      if (scale === 1) { tx = 0; ty = 0; }
      else if (cx != null) {
        /* keep the point under the fingers where it was */
        var rect = figure.getBoundingClientRect();
        var ox = cx - (rect.left + rect.width / 2), oy = cy - (rect.top + rect.height / 2);
        tx -= ox * (scale / previous - 1);
        ty -= oy * (scale / previous - 1);
      }
      apply();
    }
    function reset() { scale = 1; tx = 0; ty = 0; pointers.clear(); pinch = null; apply(); }
    function distance() {
      var pts = Array.from(pointers.values());
      return pts.length === 2 ? Math.hypot(pts[0].x - pts[1].x, pts[0].y - pts[1].y) : 0;
    }
    figure.addEventListener('pointerdown', function (event) {
      if (event.button !== 0) return;
      if (event.pointerType === 'touch') lastTouch = Date.now();
      pointers.set(event.pointerId, { x: event.clientX, y: event.clientY });
      try { figure.setPointerCapture(event.pointerId); } catch (e) { /* not capturable */ }
      if (pointers.size === 1) moved = false;
      if (pointers.size === 2) { pinch = { distance: distance(), scale: scale }; moved = true; lastTap = 0; }
    });
    figure.addEventListener('pointermove', function (event) {
      var previous = pointers.get(event.pointerId);
      if (!previous) return;
      var dx = event.clientX - previous.x, dy = event.clientY - previous.y;
      pointers.set(event.pointerId, { x: event.clientX, y: event.clientY });
      if (Math.abs(dx) + Math.abs(dy) > 3) moved = true;
      if (pointers.size === 2 && pinch && pinch.distance) {
        var pts = Array.from(pointers.values());
        setScale(pinch.scale * distance() / pinch.distance, (pts[0].x + pts[1].x) / 2, (pts[0].y + pts[1].y) / 2);
      } else if (scale > 1) {
        tx += dx; ty += dy; apply();
        event.preventDefault();
      }
    });
    function release(event) {
      pointers.delete(event.pointerId);
      if (event.type === 'pointerup' && event.pointerType === 'touch' && !moved && !pinch) {
        var now = Date.now();
        if (now - lastTap < 320) { setScale(scale > 1 ? 1 : 2.5, event.clientX, event.clientY); lastTap = 0; }
        else lastTap = now;
      }
      if (!pointers.size) pinch = null;
    }
    figure.addEventListener('pointerup', release);
    figure.addEventListener('pointercancel', release);
    figure.addEventListener('dblclick', function (event) {
      if (Date.now() - lastTouch < 600) return;
      setScale(scale > 1 ? 1 : 2.5, event.clientX, event.clientY);
    });
    figure.addEventListener('click', function (event) {
      /* a pan or pinch must not fall through to the scrim and close the view */
      if (moved) { event.stopPropagation(); event.preventDefault(); }
    }, true);
    dialog.addEventListener('close', reset);
    return { reset: reset };
  }
  var pinchZoom = initPinchZoom(zoomDialog);
  if (zoomDialog && pinchZoom) {
    zoomDialog.addEventListener('close', pinchZoom.reset);
  }

  var zoomBtn = root.querySelector('[data-llp-zoom]');
  if (zoomBtn && media) {
    zoomBtn.addEventListener('click', function () {
      var figures = solarGallery ? visibleGalleryFigures() : null;
      var figure = figures && (figures[Math.round(media.scrollLeft / media.clientWidth)] || figures[0]);
      var img = figure ? figure.querySelector('img') : media.querySelectorAll('img')[Math.round(media.scrollLeft / media.clientWidth)] || media.querySelector('img');
      if (img) openImageZoom(img, zoomBtn);
    });
  }
  // Older markup can coexist with this asset during a script-only release.
  var legacyInside = root.querySelector('[data-llp-lookinside]');
  if (legacyInside && media) legacyInside.addEventListener('click', function () {
    var inside = media.querySelector('[data-llp-view="inside"]');
    if (!inside) return;
    var left = media.scrollLeft + inside.getBoundingClientRect().left - media.getBoundingClientRect().left;
    media.scrollTo({ left: left, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
  });

  var viewNav = root.querySelector('[data-llp-views]');
  var viewButtons = [];
  function syncNotebookViews() {
    if (!viewNav || !media) return;
    var mediaRect = media.getBoundingClientRect();
    var nearest = null;
    var distance = Infinity;
    viewButtons.forEach(function (entry) {
      var image = entry.figure.querySelector('img');
      /* follow the file the view is showing: its responsive candidate, or the
         swapped-in source once a binding change has cleared the srcset */
      var shown = image && ((image.hasAttribute('srcset') && image.currentSrc) || image.src);
      if (image && entry.image.src !== shown) entry.image.src = shown;
      var currentDistance = Math.abs(entry.figure.getBoundingClientRect().left - mediaRect.left);
      if (currentDistance < distance) { distance = currentDistance; nearest = entry; }
    });
    viewButtons.forEach(function (entry) { entry.button.setAttribute('aria-pressed', entry === nearest ? 'true' : 'false'); });
  }
  if (viewNav && media) {
    media.querySelectorAll('[data-llp-view]').forEach(function (figure) {
      var original = figure.querySelector('img');
      if (!original) return;
      var button = document.createElement('button');
      button.type = 'button';
      var image = document.createElement('img');
      image.alt = ''; image.width = 48; image.height = 48; image.src = original.currentSrc || original.src;
      var label = document.createElement('span');
      label.textContent = viewNav.getAttribute(figure.getAttribute('data-llp-view') === 'front' ? 'data-front-label' : 'data-inside-label');
      button.appendChild(image); button.appendChild(label); viewNav.appendChild(button);
      viewButtons.push({ button: button, image: image, figure: figure });
      button.addEventListener('click', function () {
        var left = media.scrollLeft + figure.getBoundingClientRect().left - media.getBoundingClientRect().left;
        media.scrollTo({ left: left, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      });
    });
    viewNav.hidden = viewButtons.length < 2;
    media.addEventListener('scroll', function () { requestAnimationFrame(syncNotebookViews); }, { passive: true });
    window.addEventListener('resize', syncNotebookViews);
    syncNotebookViews();
  }

  /* ---------- CTA: straight to the editor, or direct add ---------- */
  var personalisable = cta && cta.getAttribute('data-llp-personalisable') === 'true';
  var addErrorEl = root.querySelector('[data-llp-add-error]');

  function showAddError(message) {
    if (!addErrorEl) return;
    addErrorEl.textContent = message;
    addErrorEl.hidden = false;
  }

  function clearAddError() {
    if (!addErrorEl) return;
    addErrorEl.textContent = '';
    addErrorEl.hidden = true;
  }

  /* put the button back the way Liquid rendered it, then let the current
     variant decide whether it is actually clickable */
  function restoreCta() {
    if (!cta) return;
    cta.disabled = false;
    cta.textContent = ctaDefaultLabel;
    refreshAvailability(currentVariant());
  }

  function gotoCustomise() {
    /* carry the selected variant into the editor so the chosen binding —
       not the first variant — is priced and added to the basket */
    var target = cta.getAttribute('data-llp-customise-url') || '?view=customise';
    var v = currentVariant();
    if (v && v.id) {
      try {
        var url = new URL(target, window.location.href);
        url.searchParams.set('variant', v.id);
        target = url.pathname + url.search + url.hash;
      } catch (e) {
        target += (target.indexOf('?') === -1 ? '?' : '&') + 'variant=' + v.id;
      }
    }
    window.location.href = target;
  }
  function directAdd(next) {
    var v = currentVariant();
    if (!isShopify || !v || !v.id) {
      window.location.href = next;
      return;
    }

    function failAdd(description) {
      restoreCta();
      showAddError(description || config.errorMessage || 'Sorry — we could not add that. Please try again.');
    }

    clearAddError();
    cta.disabled = true;
    cta.textContent = 'Adding…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: v.id, quantity: 1 })
    }).then(function (res) {
      if (res.ok) {
        window.location.href = next;
        return null;
      }
      /* Shopify answers a rejected add with 422 and a { description } telling
         the shopper why (out of stock, quantity limit). Show that, rather
         than leaving the click looking as if nothing happened. */
      return res.json().then(function (body) {
        return (body && (body.description || body.message)) || '';
      }, function () { return ''; });
    }).then(function (description) {
      if (description === null || description === undefined) return;
      failAdd(description);
    }, function () {
      /* network failure: the browser's own message means nothing to a shopper */
      failAdd('');
    });
  }

  if (cta) {
    cta.addEventListener('click', function () {
      /* out of stock, or no such combination: never start the editor or an add
         that checkout rejects */
      if (cta.disabled || !variantAvailable(currentVariant())) return;
      if (personalisable) {
        gotoCustomise();
      } else {
        directAdd(config.cartUrl || '/cart');
      }
    });
  }

  /* Back/forward cache restores the page exactly as it was left, so a shopper
     returning from the basket finds the button frozen on "Adding…". */
  if (typeof window !== 'undefined' && typeof window.addEventListener === 'function') {
    window.addEventListener('pageshow', function (event) {
      if (!event || !event.persisted) return;
      clearAddError();
      restoreCta();
    });
  }

  refresh();
})();
